import { createSlice } from "@reduxjs/toolkit";

const applyDirection = (language) => {
  if (typeof window === "undefined") {
    return;
  }

  const direction = language === "ar" ? "rtl" : "ltr";

  document.documentElement.setAttribute("dir", direction);
  document.documentElement.setAttribute("lang", language || "en");
};

export const LanguageSlice = createSlice({
  name: "language",
  initialState: { language: "ar" },
  reducers: {
    setLanguage: (state, action) => {
      const nextLanguage = action.payload || "ar";
      state.language = nextLanguage;

      if (typeof window !== "undefined") {
        localStorage.setItem("appLanguage", nextLanguage);
      }

      applyDirection(nextLanguage);
    },
    loadLanguage: (state) => {
      if (typeof window !== "undefined") {
        const stored = localStorage.getItem("appLanguage");

        if (stored) {
          state.language = stored;
        }
      }

      applyDirection(state.language);
    },
  },
});

export default LanguageSlice.reducer;

export const { setLanguage, loadLanguage } = LanguageSlice.actions;
